var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinibarsOngoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #b82abe;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.53,
    y: 9.25,
    width: 4,
    height: 20.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 5.9,
    y: 7.27,
    width: 4,
    height: 22.73
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 11.27,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 16.63,
    y: 7.63,
    width: 4,
    height: 22.37
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 22,
    y: 9.25,
    width: 4,
    height: 20.75
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 27.37,
    y: 8.48,
    width: 4,
    height: 21.52
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 32.74,
    y: 8.48,
    width: 4,
    height: 21.52
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 38.11,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 43.47,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 48.84,
    y: 4.96,
    width: 4,
    height: 25.04
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 54.21,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 59.58,
    y: 4.62,
    width: 4,
    height: 25.38
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 64.95,
    y: 2.99,
    width: 4,
    height: 27.01
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 70.32,
    y: 4.62,
    width: 4,
    height: 25.38
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 75.68,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 81.05,
    y: 6.68,
    width: 4,
    height: 23.32
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 86.42,
    y: 2.64,
    width: 4,
    height: 27.36
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 91.79,
    width: 4,
    height: 30
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 97.16,
    y: 1.73,
    width: 4,
    height: 28.27
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 102.53,
    width: 4,
    height: 30
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 107.89,
    y: 2.64,
    width: 4,
    height: 27.36
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 113.26,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 118.63,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 124,
    y: 8.36,
    width: 4,
    height: 21.64
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 129.37,
    y: 11.18,
    width: 4,
    height: 18.82
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 134.73,
    y: 8.36,
    width: 4,
    height: 21.64
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 140.1,
    y: 6.33,
    width: 4,
    height: 23.67
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 145.47,
    y: 6.33,
    width: 4,
    height: 23.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinibarsOngoing);
export default __webpack_public_path__ + "static/media/minibars-ongoing.9917b4ec3bbdc911aba4b3a21b87b6f0.svg";
export { ForwardRef as ReactComponent };